import IconComponent from "icons/IconComponent";

import NewOrderIcon from "./NewOrderIcon.svg";

export default (NewOrderIcon as any) as IconComponent;
